// Pseudo-classes which we simulate during playback. The enumeration values are
// used as either CSS class names or attribute names; see PseudoClassManager for
// more information.
export enum SimulatedPseudoClass {
  Focus = '_fs_focus',
  FocusWithin = '_fs_focus-within',
  Hover = '_fs_hover',
}

export const OriginalTagAttr = '_fs_original_tag';
